import selfBillingRoutes from '@/contexts/selfBillingContext/routes';
import adminRoutes from '@platformAdministrationContext/public/routes';
import partnershipsRoutes from '@partnershipsContext/public/routes';
import digitalQueuesRoutes from '@/contexts/digitalQueuesContext/routes';
import accountingRoutes from '@/contexts/accountingContext/routes';
import contractorsRoutes from '@/contexts/contractorsContext/routes';
import executorsLookupRoutes from '@/contexts/executorsLookupContext/routes';
import freightExecutionRoutes from '@/contexts/freightExecutionContext/routes';
import orderingRoutes from '@/contexts/orderingContext/routes';
import pricingRoutes from '@/contexts/pricingContext/routes';
import resourcesControlRoutes from '@/contexts/resourcesControlContext/routes';
import summaryRoutes from '@/contexts/summaryContext/routes';
import tendersRoutes from '@/contexts/tendersContext/routes';
import directionsRoutes from '@/contexts/directionsContext/routes';
import rateManagementRoutes from '@/contexts/rateManagementContext/routes';
import quotasRoutes from '@/contexts/quotaContext/routes';
import reportRoutes from '@/contexts/reportsContext/routes';
import extraServicesRoutes from '@/contexts/extraServicesContext/routes';
import operationalDocumentsRoutes from '@/contexts/operationalDocumentsContext/routes';
import approvalsRoutes from '@/contexts/approvalsContext/routes';
import referencesRoutes from '@/contexts/referencesContext/routes';

import commonRoutes from './routes/common';

/**
 * в проекте используются три типа роутов (ROUTE_TYPE):
 * - private – роут, на который может зайти только авторизованный юзер
 * - public – роут, который доступен всем юзерам
 * - unauthenticated – сюда может зайти только неавторизованный пользователь (например, signUp)
 */

export const allRoutes = [
  ...commonRoutes,
  ...accountingRoutes,
  ...orderingRoutes,
  ...resourcesControlRoutes,
  ...contractorsRoutes,
  ...digitalQueuesRoutes,
  ...partnershipsRoutes,
  ...pricingRoutes,
  ...freightExecutionRoutes,
  ...executorsLookupRoutes,
  ...adminRoutes,
  ...summaryRoutes,
  ...selfBillingRoutes,
  ...tendersRoutes,
  ...directionsRoutes,
  ...rateManagementRoutes,
  ...quotasRoutes,
  ...reportRoutes,
  ...extraServicesRoutes,
  ...operationalDocumentsRoutes,
  ...approvalsRoutes,
  ...referencesRoutes,
];
